import React, { Component } from 'react'
import ReactGA from 'react-ga'
import styled from 'styled-components'
import { Icon, Error } from './'
const Wrapper = styled.div`
  position: relative;
  width: 100%;
  & > svg:first-child {
    position: absolute;
    left: 18px;
    top: 10px;
  }
  & > div {
    /* position: absolute;
    right: 18px;
    top: 10px; */
  }
  ${props =>
    props.styleType === 'select' &&
    `
  &>svg{
    display: none;
  }
  
  `};
`
const StyledInput = styled.input`
  border-radius: ${props => (props.noSearch ? '5px' : '5px 0 0 5px')};
  background-color: #fff;
  width: 100%;
  border: none;
  padding: ${props => (props.noSearch ? '12px' : '12px 40px')};
  outline: none;
  font-family: Chivo !important;
  font-size: 14px !important;
  font-weight: normal !important;
  font-style: normal !important;
  font-stretch: normal !important;
  line-height: 1.21 !important;
  letter-spacing: normal !important;
  color: #124b5f !important;
  &::placeholder {
    font-size: 14px;
    line-height: 1.21;
    color: rgba(18, 75, 95, 0.5);
    font-family: Chivo;
  }

  &:-ms-input-placeholder {
    font-size: 14px;
    line-height: 1.21;
    color: rgba(18, 75, 95, 0.5);
    font-family: Chivo;
  }

  &::-ms-input-placeholder {
    font-size: 14px;
    line-height: 1.21;
    color: rgba(18, 75, 95, 0.5);
    font-family: Chivo;
  }
  ${props =>
    props.styleType === 'select' &&
    `
  border-radius: 100px;
  padding-left: 24px;

  `};
  ${props =>
    props.error &&
    `
  border: 2px solid #f44336;
  `};
`
const TopWrap = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  border-radius: 5px;
  ${props =>
    props.fixed &&
    `
    position: fixed;
    z-index: 99999999;
    left: auto;
    width: calc(100% - 32px);
    max-width: 734px;
  `};
  ${props =>
    props.textInput &&
    `
    width: 100%;
    box-shadow: none !important;
  `};
`

const RightIconWrap = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
  border-radius: 0 5px 5px 0;
  background-color: #fff;
  padding-right: 16px;
`

class Input extends Component {
  state = {}
  trackButtonClick = () => {
    console.log('clicked', this.props.namespace)
    this.props.onClickIcon(this.props.value === '' ? 'scan' : 'close')
    ReactGA.event({
      category: this.props.namespace || 'default',
      action: 'Button Clicked',
      label: 'default',
      nonInteraction: true
    })
  }
  render() {
    const {
      error,
      onClickIcon,
      value,
      styleType,
      fixed,
      onFocusInput,
      onClickWrapper,
      rightIconName,
      noSearch,
      textInput,
      ...props
    } = this.props
    return (
      <TopWrap fixed={fixed} textInput={textInput}>
        <Wrapper styleType={styleType} onClick={() => (onClickWrapper ? onClickWrapper() : null)}>
          {!noSearch && <Icon icon="search" />}

          <StyledInput
            value={value}
            styleType={styleType}
            error={error}
            noSearch={noSearch}
            onFocus={() => (onFocusInput ? onFocusInput() : null)}
            {...props}
          />
          <Error styleType={styleType}>{error}</Error>
        </Wrapper>
        {onClickIcon && (
          <RightIconWrap onClick={() => (onClickIcon ? this.trackButtonClick() : null)}>
            <Icon icon={value === '' ? 'scan' : 'close'} />
          </RightIconWrap>
        )}
      </TopWrap>
    )
  }
}

export default Input



// WEBPACK FOOTER //
// ./src/components/Input.js